import React from 'react';
import {useNavigation} from '@react-navigation/native';
import {useTheme} from 'styled-components/native';
import precisaSuporte from '../../../../assets/images/botao_suporte.webp';
import {
  Container,
  ButtonIcon,
  IconHeader,
  TitleContainer,
  Title,
  NeedSupportButtonImage,
} from './styles';
import {FocusAwareStatusBar} from '../../../../context/statusbar';
import {Platform, View} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import {PromoMarquee} from '../../../Interface/Headers/PromoMarquee';
import {SafeAreaView} from 'react-native-safe-area-context';
import {useAuth} from '../../../../context/auth';

interface IHeader {
  title?: string;
  icon?: string;
  rightIcon?: string;
  rightIconAction?: () => void;

  parentHelp?: boolean;
  action?: () => void;
  color?: string;
  statusBarColor?: string;
  statusBarLight?: boolean;
  forceDarkStatusBar?: boolean;

  showPromotionMarquee?: boolean;
  promoMarqueeData?: {
    id: number;
    text: string;
    icon: string;
    action: () => void | undefined;
  }[];
}

export function Header({
  title,
  color,
  icon,
  parentHelp = false,
  forceDarkStatusBar = false,
  statusBarColor,
  statusBarLight = false,
  rightIcon,
  rightIconAction,
  action,

  showPromotionMarquee = false,
  promoMarqueeData,
}: IHeader) {
  const navigation = useNavigation();
  const theme = useTheme();
  const {clientId} = useAuth();

  if (Platform.OS === 'web' && clientId === 'webmotors') {
    return <View style={{paddingTop: RFValue(10)}} />;
  }

  function handleGoBack() {
    if (navigation.canGoBack()) {
      navigation.goBack();
    } else {
      navigation.navigate('Initial');
    }
  }

  let betweenHeader = !!(parentHelp || rightIcon);

  return (
    <>
      <SafeAreaView edges={['top']} style={{backgroundColor: 'transparent'}}>
        {showPromotionMarquee && promoMarqueeData && (
          <PromoMarquee data={promoMarqueeData} />
        )}

        <Container
          style={{marginTop: showPromotionMarquee ? RFValue(0) : Platform.OS === 'android' ? RFValue(16) : RFValue(0)  }}
          between={betweenHeader}>
          <FocusAwareStatusBar
            barStyle={statusBarLight ? 'light-content' : 'dark-content'}
            backgroundColor={statusBarColor ? statusBarColor : 'transparent'}
            forceDark={forceDarkStatusBar}
          />

          {icon ? (
            <ButtonIcon
              onPress={action ? action : () => handleGoBack()}
              activeOpacity={1}>
              <IconHeader
                name={icon}
                style={{
                  color: color ? color : theme.colors.title,
                }}
              />
            </ButtonIcon>
          ) : (
            <ButtonIcon />
          )}

          {parentHelp || rightIcon ? (
            title ? (
              <Title>{title}</Title>
            ) : null
          ) : (
            <TitleContainer>
              {title ? <Title>{title}</Title> : null}
            </TitleContainer>
          )}

          {parentHelp && (
            <ButtonIcon
              rightPosition
              onPress={() => navigation.navigate('Help')}
              activeOpacity={1}>
              <NeedSupportButtonImage
                source={precisaSuporte}
                resizeMode="contain"
              />
            </ButtonIcon>
          )}

          {rightIcon && (
            <ButtonIcon
              rightPosition
              onPress={rightIconAction}
              activeOpacity={1}>
              <IconHeader
                name={rightIcon}
                style={{
                  color: color ? color : theme.colors.title,
                }}
              />
            </ButtonIcon>
          )}
        </Container>
      </SafeAreaView>
    </>
  );
}
